// One orb answer sentence in a text field: shows the user's own text if they
// wrote one, else the generated sentence; an empty field shows the question.
// Clearing or retyping the generated sentence hands it back to auto (null).
import React, { useEffect, useState } from 'react';
import { Text, TextInput, View } from 'react-native';
import { useV10, DISPLAY_FONT } from '../theme';
import { useK } from './ui';

export function SentenceField({
  question,
  said,
  generated,
  disabledHint,
  onCommit,
}: {
  question: string;
  /** The user's saved sentence, or null for auto. */
  said: string | null;
  generated: string;
  /** Shown (and the field locked) when there is nothing to answer for yet. */
  disabledHint?: string | null;
  onCommit: (value: string | null) => void;
}) {
  const t = useV10();
  const k = useK();
  const value = said ?? generated;
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  const commit = () => {
    if (draft === value) return;
    onCommit(draft === generated ? null : draft);
  };
  return (
    <View style={{ alignSelf: 'stretch', gap: 8 * k }}>
      <TextInput
        value={draft}
        onChangeText={setDraft}
        onBlur={commit}
        placeholder={question}
        placeholderTextColor={t.ivoryFaint}
        editable={!disabledHint}
        multiline
        maxLength={400}
        style={[
          {
            alignSelf: 'stretch',
            minHeight: 52 * k,
            paddingHorizontal: 10 * k,
            paddingVertical: 8 * k,
            borderRadius: 10 * k,
            borderWidth: 1,
            borderColor: 'rgba(214,180,106,0.35)',
            color: t.ivory,
            fontSize: 13 * k,
            lineHeight: 18 * k,
            textAlignVertical: 'top',
          },
          { outlineStyle: 'none' } as object,
        ]}
      />
      {disabledHint ? (
        <Text style={{ color: t.ivoryFaint, fontFamily: DISPLAY_FONT, fontStyle: 'italic', fontSize: 10.5 * k }}>{disabledHint}</Text>
      ) : null}
    </View>
  );
}
